import { useState } from 'react';
import {
  Group,
  Header,
  Search,
  SimpleCell,
  Spinner,
  Button,
  File,
  Snackbar,
} from '@vkontakte/vkui';
import {
  useParticipants,
  useImportParticipants,
  useImportJob,
} from '../../api/hooks';
import { api } from '../../api/client';

export function AdminParticipants() {
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [jobId, setJobId] = useState<string | null>(null);
  const { data, isLoading } = useParticipants(page, search);
  const importMut = useImportParticipants();
  const job = useImportJob(jobId);

  const handleFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    importMut.mutate(file, {
      onSuccess: (r) => setJobId(r.jobId),
    });
  };

  return (
    <>
      <Group header={<Header size="s">Импорт участников</Header>}>
        <File accept=".xlsx,.csv" onChange={handleFile}>
          Загрузить XLSX/CSV
        </File>
        {job.data?.report && (
          <SimpleCell
            subtitle={`Добавлено: ${job.data.report.added}, пропущено: ${job.data.report.skipped}, ошибок: ${job.data.report.errors}`}
          />
        )}
      </Group>
      <Group header={<Header size="s">Список</Header>}>
        <Search
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setPage(1);
          }}
          placeholder="ID, email, ФИО"
        />
        {isLoading ? (
          <Spinner />
        ) : (
          data?.participants?.map((p) => (
            <SimpleCell
              key={p.id as number}
              subtitle={`${p.email} · ${p.status}`}
              after={
                p.status === 'active' ? (
                  <Button
                    size="s"
                    mode="outline"
                    onClick={() =>
                      api(`/api/admin/participants/${p.id}`, {
                        method: 'DELETE',
                      }).then(() => window.location.reload())
                    }
                  >
                    Сброс VK
                  </Button>
                ) : null
              }
            >
              {p.fullName as string} ({p.idPervye as number})
            </SimpleCell>
          ))
        )}
        <SimpleCell>
          <Button
            disabled={page <= 1}
            onClick={() => setPage((p) => p - 1)}
          >
            Назад
          </Button>
          <Button onClick={() => setPage((p) => p + 1)}>Вперёд</Button>
        </SimpleCell>
      </Group>
      {importMut.isError && (
        <Snackbar>{(importMut.error as Error).message}</Snackbar>
      )}
    </>
  );
}
